import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { EstimationCreditsComponent } from './estimation-credits.component';

@NgModule({
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [EstimationCreditsComponent],
    declarations: [EstimationCreditsComponent],
})
export class EstimationCreditsModule {}
